import { createAction } from '../../techstyle-shared/redux-core';

export const trackDmgPageView = createAction('dmg/TRACK_PAGE_VIEW');

export const trackHomePageView = createAction('/homepage/TRACK_PAGE_VIEW');

export const trackPromoPickerPageView = createAction(
  '/promo-picker/TRACK_PAGE_VIEW'
);

export const trackErrorPageRendered = createAction('trackErrorPageRendered');

export function errorPageRendered(url, statusCode) {
  return {
    type: trackErrorPageRendered.type,
    url,
    statusCode,
  };
}
export const trackFirstMemberBillingModalPageView = createAction(
  '/fmbe-modal/TRACK_PAGE_VIEW'
);
